module.exports = "pegasus/assets/custom-2-facebook.png";